import { render, staticRenderFns } from "./FPotensiCarousel.vue?vue&type=template&id=76f6dd3a&scoped=true"
import script from "./FPotensiCarousel.vue?vue&type=script&lang=js"
export * from "./FPotensiCarousel.vue?vue&type=script&lang=js"
import style0 from "./FPotensiCarousel.vue?vue&type=style&index=0&id=76f6dd3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f6dd3a",
  null
  
)

export default component.exports